import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Person = styled.div<{ withoutMargin: boolean }>`
    display: flex;
    flex-direction: column;
    width: 17%;
    margin: 0 ${(prop) => (prop.withoutMargin ? 0 : 'auto')} ${rem(20)} ${(prop) => (prop.withoutMargin ? 0 : 'auto')};

    @media (max-width: ${breakpoints.md}px) {
        width: 30%;
    }

    @media (max-width: ${breakpoints.sm}px) {
        width: 40%;
    }

    @media (max-width: ${breakpoints.xs}px) {
        width: 100%;
    }

`;

export const PersonDetail = styled.div<{ width: number }>`
    background: ${({ theme }) => theme.colors.white};
    font-size: ${({ theme }) => theme.fontSizes.textMedium};
    padding: ${rem(20)} 0;

    display: flex;
    flex-direction: column;
    width: ${(prop) => (prop.width ? rem(prop.width) : '100%')};
`;

export const PersonName = styled.div`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
`;

export const PersonPosition = styled.div`
    padding: ${rem(5)} 0 ${rem(25)} 0;
    height: ${rem(60)};
`;

export const PersonPhone = styled.a`
    padding-bottom: ${rem(5)};
    color: ${({ theme }) => theme.colors.black};
    cursor: pointer;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primary};
`;

export const PersonMail = styled.a`
    color: ${({ theme }) => theme.colors.primary};
    cursor: pointer;
    text-decoration: none;
    margin-top: auto;
`;

export const PersonImage = styled.img<{ width: number }>`
    width: ${(prop) => (prop.width ? rem(prop.width) : '100%')};
    height: auto;
    border-radius: ${rem(16)};
`;
